<template>
  <div class="body">
    <MovieItemFeed :listType="listType"></MovieItemFeed>
  </div>
</template>

<script>

  import MovieItemFeed from "./MovieItemFeed";
  export default {
    name: "FavoriteFeed",
    components: {MovieItemFeed},
    data() {
      return {
        listType: "favorite",
      }
    },

    mounted() {
    },

    activated() {
    },

    methods: {
    },
  };
</script>

<style lang="scss" scoped>
  .body {
    z-index: 1000;
  }

</style>
